export default __webpack_public_path__ + "static/newsletter-mobile-8c8083b19dba41896a245786a221a711.jpg";